import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=4a0b7e0e&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a0b7e0e')) {
      api.createRecord('4a0b7e0e', component.options)
    } else {
      api.reload('4a0b7e0e', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=4a0b7e0e&", function () {
      api.rerender('4a0b7e0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/leads/Edit/Main.vue"
export default component.exports